module.exports = __webpack_public_path__ + "img/1440.399bb28c.jpg";